import { CardsListFilters, CardsState, CardsStateArgs } from './types';

const defaultCardsProviderState = ({ popularCards }: CardsStateArgs): CardsState => ({
  cardListData: null,
  isCorporate: false,
  pagination: {
    pageNumber: 0,
    pageSize: 10,
  },
  meta: {
    timestamp: new Date().toISOString(),
  },
  popularCards,
  cardsListFilters: {},
  onCardsListFiltersChange: (filters: Partial<CardsListFilters>, nextPage?: number, totalPages?: number) => {},
  errorState: {
    cardListDataError: undefined,
  },
  loadingState: {
    isLoadingCardListData: false,
  },
  onSetPopularCards: () => {},
  onSetPagination: () => {},
});

export { defaultCardsProviderState };
